import {
    APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_LOADING,
    APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_SUCCESS,
    CREATE_APPLICATION_PENDING,
    CREATE_APPLICATION_SUCCESS,
    DOCUMENT_REQUIREMENTS_COMPLETE,
    DOCUMENT_REQUIREMENTS_LOADING,
    SHOW_UPLOAD_DOCUMENTS_STEP,
    SHOW_APPLICATION_STEP,
    APPLY_FLEXI_LOAN_DATA,
    DEACTIVATE_APPLY_FLEXI_LOAN
} from './ApplyFlexiLoanView.actions';

const initialState = {
    ready: false,
    approvalRequirementsLoading: false,
    submitApplicationLoading: false,
    formStep: 'createApplication',
    createApplicationLoading: false,
    isEditingAmount: false
};

type ApplyFlexiLoanViewActionTypes = {
    type:
        | typeof APPLY_FLEXI_LOAN_DATA
        | typeof APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_LOADING
        | typeof APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_SUCCESS
        | typeof CREATE_APPLICATION_PENDING
        | typeof CREATE_APPLICATION_SUCCESS
        | typeof DOCUMENT_REQUIREMENTS_COMPLETE
        | typeof DOCUMENT_REQUIREMENTS_LOADING
        | typeof SHOW_APPLICATION_STEP
        | typeof SHOW_UPLOAD_DOCUMENTS_STEP
        | typeof DEACTIVATE_APPLY_FLEXI_LOAN;
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = initialState,
    action: ApplyFlexiLoanViewActionTypes
) {
    switch (action.type) {
        case APPLY_FLEXI_LOAN_DATA:
            return {
                ...state,
                ready: true
            };
        case DEACTIVATE_APPLY_FLEXI_LOAN:
            return {
                ...initialState
            };
        case CREATE_APPLICATION_PENDING:
            return {
                ...state,
                createApplicationLoading: true
            };
        case CREATE_APPLICATION_SUCCESS:
            return {
                ...state,
                createApplicationLoading: false
            };
        case DOCUMENT_REQUIREMENTS_LOADING:
            return {
                ...state,
                approvalRequirementsLoading: true
            };

        case DOCUMENT_REQUIREMENTS_COMPLETE:
            return {
                ...state,
                approvalRequirementsLoading: false
            };

        case APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_LOADING:
            return {
                ...state,
                submitApplicationLoading: true
            };
        case APPLY_FLEXI_LOAN_SUBMIT_APPLICATION_SUCCESS:
            return {
                ...state,
                submitApplicationLoading: false
            };
        case SHOW_APPLICATION_STEP:
            return {
                ...state,
                formStep: 'createApplication'
            };
        case SHOW_UPLOAD_DOCUMENTS_STEP:
            return {
                ...state,
                formStep: 'uploadDocuments',
                isEditingAmount: false
            };
        default:
            return state;
    }
}
